import {Button, Dialog, DialogContentText, Slide, useTheme} from '@mui/material';
import {TransitionProps} from '@mui/material/transitions';
import AutoHeight from 'embla-carousel-auto-height';
import React, {Fragment} from 'react';

import {FiveStarsEnum} from 'main/analytics/gaTagsEnum';
import Image from 'presentation/assets/images/general-review.svg';
import {Carousel} from 'presentation/components';
import {useCarrouselIndexStore} from 'presentation/components/Carrousel/store';
import {CarrouselTypeEnum} from 'presentation/constants/carrouselTypeEnum';
import {translations} from 'presentation/translations-new';
import {useMobileRatingModal} from '../../../hooks/useMobileRatingModal';
import {MobileRefuseEvaluation} from '../MobileRefuseEvaluation';
import {MobileSelectEvaluationsProps} from '../types';
import {
	ImageContainer,
	StyledButtonContainer,
	StyledCarouselContainer,
	StyledDialogContent,
	StyledDialogHeader,
} from './styles';

const {rateYourAttendance, dontWantRate, rateThisAttendance, rateYourAttendances} =
	translations['pt-br'].privateFlow.fiveStarsRating;

const Transition = React.forwardRef(
	(
		props: TransitionProps & {
			children: React.ReactElement;
		},
		ref: React.Ref<unknown>,
	) => <Slide direction="up" ref={ref} exit={false} timeout={1000} {...props} />,
);

const tutorialAndTooltipZIndexPlus1 = 10_101;

export function MobileSelectEvaluations({ratings, ratingDetail}: MobileSelectEvaluationsProps) {
	const {palette} = useTheme();

	const carrouselIndex = useCarrouselIndexStore(state => state.carrouselIndex);

	const {handleOpenRefuseToEvaluateModal, handleGoToEvaluationPage, refuseModal} =
		useMobileRatingModal();

	const headerTitle = ratings.count > 1 ? rateYourAttendances : rateYourAttendance;

	return (
		<Fragment>
			<Dialog
				open={true}
				fullScreen
				slots={{
					transition: Transition,
				}}
				sx={{
					zIndex: tutorialAndTooltipZIndexPlus1,
				}}
				slotProps={{
					paper: {
						sx: {
							backgroundColor: palette.grey[200],
						},
					},
				}}>
				<StyledDialogHeader>{headerTitle}</StyledDialogHeader>
				<StyledCarouselContainer>
					<Carousel
						numbersText="avaliações"
						controlledIndex
						plugins={[AutoHeight()]}
						options={{loop: true}}
						type={CarrouselTypeEnum.NUMBERS}
						slides={ratings.items.map(rating => (
							<StyledDialogContent key={rating.keys.cdatendimento}>
								<ImageContainer>
									<img
										src={Image}
										alt="Uma pessoa com uma mochila nas costas e uma lupa na mão, está olhando para uma bifurcação no caminho, sem saber qual direção seguir."
										width={140}
										height={140}
									/>
								</ImageContainer>
								<DialogContentText color="text.primary" textAlign="center" mt={2}>
									{rating.values.info.info[0]}
								</DialogContentText>
							</StyledDialogContent>
						))}
					/>
				</StyledCarouselContainer>
				<StyledButtonContainer>
					<Button
						fullWidth
						size="large"
						data-tag-id={FiveStarsEnum.CLICK_AVALIAR_ATENDIMENTO}
						onClick={() =>
							handleGoToEvaluationPage({
								cdAtendimento: ratings.items[carrouselIndex].keys.cdatendimento,
								tipo: ratings.items[carrouselIndex].keys.tipo,
							})
						}>
						{rateThisAttendance}
					</Button>
					<Button
						fullWidth
						size="large"
						variant="outlined"
						data-tag-id={FiveStarsEnum.CLICK_NAO_QUERO_AVALIAR}
						onClick={() =>
							handleOpenRefuseToEvaluateModal({
								cdAtendimento: ratings.items[carrouselIndex].keys.cdatendimento,
								tipo: ratings.items[carrouselIndex].keys.tipo,
							})
						}>
						{dontWantRate}
					</Button>
				</StyledButtonContainer>
			</Dialog>
			{refuseModal ? <MobileRefuseEvaluation ratingDetail={ratingDetail} /> : null}
		</Fragment>
	);
}
